import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { datetime } from "@silvertours/front-shared";
import { Information, OpeningHours, ScheduleRow } from "./OpeningTimes.styles";
import { useSiteInfo } from "../../SiteInfo";
export var Schedule = function(param) {
    var showVoucherInfo = param.showVoucherInfo;
    var ref = useSiteInfo(), language = ref.settings.language, openingTimes = ref.openingTimes;
    var locale = datetime.dateLocales[language];
    var ref1 = _sliced_to_array([
        1,
        5,
        6,
        0
    ].map(function(day) {
        return locale.localize.day(day, {
            width: "abbreviated"
        });
    }), 4), monday = ref1[0], friday = ref1[1], saturday = ref1[2], sunday = ref1[3];
    var commonSchedule = Object.entries(openingTimes.common).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], hours = _param[1];
        if (typeof hours === "undefined") {
            return undefined;
        }
        var open = hours.open, close = hours.close;
        var days;
        switch(key){
            case "always":
                days = "".concat(monday, " - ").concat(sunday);
                break;
            case "weekdays":
            case "workdays":
                days = "".concat(monday, " - ").concat(friday);
                break;
            case "weekends":
                days = "".concat(saturday, " - ").concat(sunday);
                break;
            case "saturday":
                days = saturday;
                break;
            case "sunday":
                days = sunday;
                break;
            default:
                days = key;
        }
        return /*#__PURE__*/ _jsxs(ScheduleRow, {
            type: "common",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: days
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        open,
                        " - ",
                        close
                    ]
                })
            ]
        }, key);
    }).filter(Boolean);
    return /*#__PURE__*/ _jsx(OpeningHours, {
        textColor: "grey",
        showVoucherInfo: showVoucherInfo,
        children: /*#__PURE__*/ _jsx(Information, {
            children: openingTimes.common ? commonSchedule : null
        })
    });
};
